import script from "./EmptyStatePatients.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyStatePatients.vue?vue&type=script&setup=true&lang=js"

import "./EmptyStatePatients.vue?vue&type=style&index=0&id=e9a4af30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9a4af30"]])

export default __exports__